export default __webpack_public_path__ + "static/media/LightwhiteCrossClose.21785371.svg";